import * as React from "react";
import { forwardRef } from "react";
const SvgCurveRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 268, height: 71, viewBox: "0 0 268 71", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3 3H215C242.614 3 265 25.3858 265 53V68", stroke: "#EFEFEF", strokeWidth: 6, strokeLinecap: "round", strokeDasharray: "0.2 12" }));
const ForwardRef = forwardRef(SvgCurveRight);
export default ForwardRef;
